export default "__VITE_ASSET__LxL$VFbUxVtNn_zbs7yz7w__"